import { buildCollection, EntityReference } from "@camberi/firecms";

type Users = {
	email: string; // disabled: true,
	role: string;
	collab_jobs: EntityReference[];
	collab_projects: EntityReference[];
	collab_assets: EntityReference[];
	status: string;
};

export default buildCollection<Users>({
	icon: "AdminPanelSettings",
	name: "Users",
	singularName: "User",
	path: "users",
	group: "Admin",
	permissions: ({ authController }) => ({
		edit: true,
		create: false,
		// we have created the roles object in the navigation builder
		delete: false,
	}),
	properties: {
		email: {
			name: "Email",
			disabled: true,
			dataType: "string",
		},
		collab_jobs: {
			dataType: "array",
			name: "Jobs Collaborator",
			description: "All Jobs the user has access to. Includes linked Project and Assets.",
			of: {
				previewProperties: ["name"],
				dataType: "reference",
				path: "jobs",
			},
		},
		collab_projects: {
			dataType: "array",
			name: "Projects Collaborator",
			description: "All Projects the user has access to. Includes linked Assets.",
			of: {
				previewProperties: ["name"],
				dataType: "reference",
				path: "projects",
			},
		},
		collab_assets: {
			dataType: "array",
			name: "Asset Collaborator",
			description: "All Assets the user has access to.",
			of: {
				previewProperties: ["name"],
				dataType: "reference",
				path: "assets",
			},
		},
		role: {
			name: "Roles",
			validation: { required: true },
			dataType: "string",
			enumValues: {
				admin: "ADMIN",
				service: "SERVICE",
				user: "USER",
				none: "None",
			},
		},
		status: {
			name: "Status",
			validation: { required: true },
			dataType: "string",
			description: "Should this product be visible in the website",
			longDescription:
				"Example of a long description hidden under a tooltip. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin quis bibendum turpis. Sed scelerisque ligula nec nisi pellentesque, eget viverra lorem facilisis. Praesent a lectus ac ipsum tincidunt posuere vitae non risus. In eu feugiat massa. Sed eu est non velit facilisis facilisis vitae eget ante. Nunc ut malesuada erat. Nullam sagittis bibendum porta. Maecenas vitae interdum sapien, ut aliquet risus. Donec aliquet, turpis finibus aliquet bibendum, tellus dui porttitor quam, quis pellentesque tellus libero non urna. Vestibulum maximus pharetra congue. Suspendisse aliquam congue quam, sed bibendum turpis. Aliquam eu enim ligula. Nam vel magna ut urna cursus sagittis. Suspendisse a nisi ac justo ornare tempor vel eu eros.",
			enumValues: {
				created: "Created",
				active: "Active",
				disabled: "Disabled",
				deleted: "Deleted",
			},
		},
	},
});
